module.exports = __webpack_public_path__ + "img/benefit-logo-4.cf0b8fa2.svg";